import { useQueryClient } from "@tanstack/react-query";

import { flocknoteKeys } from "Flocknote/API/keys";

const useInvalidateNetworkMetadata = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: flocknoteKeys.network(),
    });
  };
};

export { useInvalidateNetworkMetadata };
